import { render } from "./TableHeaders.vue?vue&type=template&id=797b18ac&scoped=true"
import script from "./TableHeaders.vue?vue&type=script&lang=js"
export * from "./TableHeaders.vue?vue&type=script&lang=js"

import "./TableHeaders.vue?vue&type=style&index=0&id=797b18ac&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797b18ac"]])

export default __exports__